export const MAX_GROUP_DEPTH = 3;
